import { placementComputed, placementMethods } from 'vx/helpers'

export default {
  computed: {
    ...placementComputed
  },

  methods: {
    ...placementMethods,

    /**
     * Approve placement and set status on frontend to signed off
     */
    async handleApprovePlacement () {
      await this.approveStartComponent({ graduate: this.placement.graduate_id, placement: this.placement })

      this.setPlacementProperty({ property: 'start_component.status', value: 'signed_off' })
      this.$noty.success('Successfully approved')
    }
  }
}
